<template>
  <div>
    <el-form
      :model="selectedContractors"
      ref="formedForm"
      label-position="top"
      label-width="120px"
    >
      <el-row :gutter="10">
        <el-col :span="24">
          <el-form-item label="Наименование">
            <el-select
              style="width: 100%"
              :disabled="typeWriteTitle"
              class="searchPole"
              clearable
              v-model="selectedContractors.egr"
              filterable
              remote
              value-key="id"
              reserve-keyword
              placeholder="Полное наименование"
              :remote-method="getEgrNames"
            >
              <el-option
                v-for="item in egrNamesList"
                :key="item.id"
                :label="item.name"
                :value="item"
              >
              </el-option>
            </el-select>
            <el-checkbox @change="changeTypeWriteTitle" v-model="typeWriteTitle"
              >Ручной ввод наименования</el-checkbox
            >
            <el-input
              :disabled="!typeWriteTitle"
              v-model="selectedContractors.nameManual"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="10">
        <el-col :span="12">
          <el-form-item label="Местонахождение (юридический адрес)">
            <el-input
              v-if="typeWriteTitle"
              v-model="selectedContractors.addressManual"
            ></el-input>
            <p v-else>{{ selectedContractors.addressManual }}</p>
          </el-form-item>
        </el-col>

        <el-col :span="12">
          <el-form-item label="Телефон, факс">
            <el-input
              v-if="typeWriteTitle"
              v-model="selectedContractors.phoneNumberManual"
            ></el-input>
            <p v-else v-html="selectedContractors.phoneNumberManual"></p>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="10">
        <el-col :span="6">
          <el-form-item label="Номер договора">
            <el-input v-model="selectedContractors.contractNumber"></el-input>
          </el-form-item>
        </el-col>

        <el-col :span="9">
          <el-form-item label="Дата подписания договора">
            <el-date-picker
              style="width: 100%"
              value-format="yyyy-MM-dd"
              format="dd.MM.yyyy"
              v-model="selectedContractors.contractDateFrom"
              type="date"
              :picker-options="pickerOptions"
            >
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="9">
          <el-form-item label="Дата окончания договора">
            <el-date-picker
              style="width: 100%"
              value-format="yyyy-MM-dd"
              format="dd.MM.yyyy"
              v-model="selectedContractors.contractDateTo"
              type="date"
              :picker-options="pickerOptions"
            >
            </el-date-picker>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="10">
        <el-col :span="9">
          <el-button 
            type="primary" 
            :disabled="allWastesChecked"
            @click="openWasteDialog"
          >
            Добавить отход
          </el-button>
        </el-col>
        <el-col :span="9">
          <el-checkbox 
            v-model="allWastesChecked"
          >
            Разрешить все отходы
          </el-checkbox>
        </el-col>
      </el-row>

      <el-row 
        :gutter="10" 
        v-if="!allWastesChecked && selectedWastes.length > 0"
      >
        <el-col :span="24">
          <el-table :data="selectedWastes" border size="small" style="width: 100%; margin-top: 10px;">
            <el-table-column prop="name" label="Наименование отхода" min-width="200" />
            <el-table-column prop="code" label="Код отхода" width="120" align="center" />
            <el-table-column prop="dangerLevel" label="Степень опасности" width="150" align="center" />
            <el-table-column label="" width="100" align="center">
              <template slot-scope="scope">
                <el-button type="primary" size="mini" @click="removeWaste(scope.row.id)">
                  Удалить
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-col>
      </el-row>

      <el-row :gutter="10">
        <el-col :span="24">
          <el-form-item label="ФИО ответственного лица, телефон">
            <el-input
              v-model="selectedContractors.responsiblePersonNamePhone"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-button @click="save" type="primary">Изменить</el-button>
      </el-row>
    </el-form>

    <el-dialog
      title="Выбор отхода"
      :visible.sync="wasteDialogVisible"
      width="600px"
      append-to-body
      destroy-on-close
    >
      <el-select
        v-model="tempWasteId"
        filterable
        placeholder="Выберите отход"
        style="width: 100%"
        value-key="ss01DictionaryId"
      >
        <el-option
          v-for="item in wasteNames"
          :key="item.ss01WasteDictionaryDTO.ss01DictionaryId"
          :label="item.ss01WasteDictionaryDTO.wasteName"
          :value="item.ss01WasteDictionaryDTO.ss01DictionaryId"
        />
      </el-select>
      <span slot="footer">
        <el-button @click="wasteDialogVisible = false">Отмена</el-button>
        <el-button type="primary" @click="confirmWasteDialog">OK</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "contractorsEdit",
  props: ["selectedContractors"],
  data() {
    return {
      pickerOptions:{
        firstDayOfWeek: 1
      },
      typeWriteTitle: false,
      wasteDialogVisible: false,
      tempWasteId: null,
      allWastesChecked: true,
    };
  },

  computed: {
    ...mapGetters({
      egrNamesList: "GETEGRNAMESLIST",
      wasteNames: "GETLISTWASTEPRODUCTION",
    }),

    selectedWastes() {
      const ids = this.selectedContractors.wasteIds || [];
      return ids
        .map(wasteId => {
          const item = this.wasteNames.find(
            w => w.ss01WasteDictionaryDTO.ss01DictionaryId === wasteId
          );
          if (!item) return null;
          return {
            id: item.ss01WasteDictionaryDTO.ss01DictionaryId,
            name: item.ss01WasteDictionaryDTO.wasteName,
            code: item.ss01WasteDictionaryDTO.wasteCode,
            dangerLevel: item.dangerDegreeClassifierDTO == null
              ? item.ss01WasteDictionaryDTO.dangerDegreeClassifierDTO?.name
              : item.dangerDegreeClassifierDTO.name,
          };
        })
        .filter(w => w !== null);
    },
  },

  methods: {
    changeTypeWriteTitle() {
      if (this.typeWriteTitle) {
        this.selectedContractors.egrId = null;
      } else {
        this.selectedContractors.nameManual = null;
      }
    },

    save() {
      this.changeTypeWriteTitle();
      if (!this.typeWriteTitle) {
        if (this.selectedContractors.egr !== undefined) {
          this.selectedContractors.egrId = this.selectedContractors.egr.id;
          this.selectedContractors.nameManual =
            this.selectedContractors.egr.name;
        }
      }
      const payload = {
        ...this.selectedContractors,
        wasteIds: this.allWastesChecked 
          ? [] 
          : (this.selectedContractors.wasteIds || []),
      };

      this.$store
      .dispatch("updateContractor", payload)
        .then((response) => {
          console.log(response);
          this.notification("Успешно", "Контрагент изменен", "success");
          this.$store.dispatch("setShowModal", null);
          this.$store.dispatch("getAllContractors", { page: 0, size: 20 });
        });
    },

    getEgrNames(query) {
      this.$store.dispatch("getEgrNames", { query: query });
    },

    openWasteDialog() {
      this.tempWasteId = null;
      this.wasteDialogVisible = true;
    },

    confirmWasteDialog() {
      if (this.tempWasteId === null) {
        this.wasteDialogVisible = false;
        return;
      }
      if (!this.selectedContractors.wasteIds.includes(this.tempWasteId)) {
        this.selectedContractors.wasteIds.push(this.tempWasteId);
      }
      this.wasteDialogVisible = false;
    },

    removeWaste(wasteId) {
      this.selectedContractors.wasteIds = 
        this.selectedContractors.wasteIds.filter(id => id !== wasteId);
    },

    async getWasteNames() {
      await this.$store.dispatch(
        "getOrganizationWastesListByOrganizationIdAndDate",
        null
      );
    },
  },
  async mounted() {
    if (this.selectedContractors.nameManual != null) {
      this.typeWriteTitle = true;
      this.changeTypeWriteTitle();
    }
    this.allWastesChecked = !this.selectedContractors.wasteIds?.length;

    await this.getWasteNames();
  },
};
</script>

<style scoped></style>
